export const defaultNav = [
  {
    name: "Vue相关",
    icon: "icon-vuejs1",
    children: [
      {
        name: "Vue3",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://cn.vuejs.org/",
        desc: "渐进式JavaScript 框架，易学易用，性能出色，适用场景丰富的 Web 前端框架。",
      },
      {
        name: "Vue2",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://v2.cn.vuejs.org/",
        desc: "渐进式JavaScript 框架，易用，灵活高效",
      },

      {
        name: "Vue Router",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://router.vuejs.org/zh/",
        desc: "为 Vue.js 提供富有表现力、可配置的、方便的路由",
      },
      {
        name: "Pinia",
        icon: require("@/assets/images/icon/pinia.svg"),
        link: "https://pinia.vuejs.org/zh/",
        desc: "符合直觉的Vue.js 状态管理库",
      },

      {
        name: "Vuex",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://vuex.vuejs.org/zh/",
        desc: "Vuex 是一个专为 Vue.js 应用程序开发的状态管理模式 + 库。它采用集中式存储管理应用的所有组件的状态，并以相应的规则保证状态以一种可预测的方式发生变化。",
      },
      {
        name: "create-vue",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://github.com/vuejs/create-vue",
        desc: "The recommended way to start a Vite-powered Vue project",
      },
      {
        name: "Vue CLI",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://cli.vuejs.org/zh/",
        desc: "Vue CLI 是一个基于 Vue.js 进行快速开发的完整系统",
      },
      {
        name: "Webpack",
        icon: require("@/assets/images/icon/webpack.svg"),
        link: "https://www.webpackjs.com/",
        desc: "webpack 是一个用于现代 JavaScript 应用程序的 静态模块打包工具",
      },
      {
        name: "Vite",
        icon: require("@/assets/images/icon/vite.svg"),
        link: "https://cn.vitejs.dev/",
        desc: "下一代的前端工具链，为开发提供极速响应",
      },
      {
        name: "Vue.js devtools",
        icon: require("@/assets/images/icon/vuejs.svg"),
        link: "https://github.com/vuejs/devtools",
        desc: "基于google chrome浏览器的一款调试vue.js应用的开发者浏览器扩展",
      },
    ],
  },
  {
    name: "React相关",
    icon: "icon-ui",
    children: [
      {
        name: "React",
        icon: require("@/assets/images/icon/react.svg"),
        link: "https://zh-hans.reactjs.org/",
        desc: "用于构建用户界面的 JavaScript 库",
      },
      {
        name: "React Router",
        icon: require("@/assets/images/icon/reactrouter.png"),
        link: "https://reactrouter.com/en/main",
        desc: "React Router官方文档",
      },
      {
        name: "Redux",
        icon: require("@/assets/images/icon/redux.svg"),
        link: "https://cn.redux.js.org/",
        desc: "Redux官方中文文档",
      },
      {
        name: "Mobx",
        icon: require("@/assets/images/icon/mobx.png"),
        link: "https://zh.mobx.js.org/README.html",
        desc: "Mobx官方中文文档",
      },
      {
        name: "Dvajs",
        icon: "",
        link: "https://dvajs.com/guide/",
        desc: "Dvajs官方文档",
      },
      {
        name: "Crate-React-App",
        icon: require("@/assets/images/icon/create-react-app.svg"),
        link: "https://create-react-app.dev/",
        desc: "React 官方脚手架工具",
      },
    ],
  },
  {
    name: "Node相关",
    icon: "icon-js",
    children: [
      {
        name: "nodejs文档",
        icon: require("@/assets/images/icon/nodejs.svg"),
        link: "http://nodejs.cn/",
        desc: "Node.js 是一个开源的、跨平台的 JavaScript 运行时环境。",
      },
      {
        name: "eggjs",
        icon: require("@/assets/images/icon/eggjs.svg"),
        link: "https://www.eggjs.org/zh-CN",
        desc: "为企业级框架和应用而生",
      },
      {
        name: "express",
        icon: require("@/assets/images/icon/express.png"),
        link: "https://www.expressjs.com.cn/",
        desc: "基于 Node.js 平台，快速、开放、极简的 Web 开发框架",
      },
      {
        name: "koa",
        icon: require("@/assets/images/icon/koa.png"),
        link: "https://koa.bootcss.com/",
        desc: "基于node平台的下一代web开发框架",
      },
      {
        name: "nest",
        icon: require("@/assets/images/icon/nestjs.svg"),
        link: "https://docs.nestjs.cn/",
        desc: "用于构建高效且可伸缩的服务端应用程序的渐进式 Node.js 框架。",
      },
      {
        name: "midway",
        icon: require("@/assets/images/icon/midway.svg"),
        link: "https://midwayjs.org/",
        desc: "Midway 是阿里巴巴 - 淘宝前端架构团队，基于渐进式理念研发的 Node.js 框架，通过自研的依赖注入容器，搭配各种上层模块，组合出适用于不同场景的解决方案",
      },
      {
        name: "NVM",
        icon: "",
        link: "https://github.com/nvm-sh/nvm",
        desc: "nvm (Node Version Manager) 是Nodejs版本管理器，可对不同的node版本快速进行切换。",
      },
      {
        name: "nvm-windows",
        icon: "",
        link: "https://github.com/coreybutler/nvm-windows",
        desc: "nvm (Node Version Manager) 是Nodejs版本管理器，可对不同的node版本快速进行切换。",
      },
    ],
  },
  {
    name: "小程序/公众号",
    icon: "icon-xiaochengxu1",
    children: [
      {
        name: "微信小程序文档",
        icon: require("@/assets/images/icon/miniprogram.png"),
        link: "https://developers.weixin.qq.com/miniprogram/dev/index.html",
        desc: "微信小程序官方开发者文档",
      },
      {
        name: "微信开放社区",
        icon: require("@/assets/images/icon/wx-community.svg"),
        link: "https://developers.weixin.qq.com/community/develop/question",
        desc: "小程序开发者专区，微信公众平台,微信开放社区,开发者专区",
      },
      {
        name: "Vant Weapp",
        icon: require("@/assets/images/icon/vant-weapp.png"),
        link: "https://vant-contrib.gitee.io/vant-weapp/#/home",
        desc: "轻量、可靠的小程序 UI 组件库",
      },
      {
        name: "WeUI",
        icon: "",
        link: "https://github.com/Tencent/weui",
        desc: "一套同微信原生视觉体验一致的基础样式库 为微信 Web 开发量身设计，令用户的使用感知更加统一",
      },
      {
        name: "WePY",
        icon: require("@/assets/images/icon/wepy.png"),
        link: "https://wepyjs.github.io/wepy-docs/",
        desc: "支持组件化的小程序开发框架",
      },
    ],
  },
  {
    name: "UI框架",
    icon: "icon-ui",
    children: [
      {
        name: "Element Plus",
        icon: require("@/assets/images/icon/element-plus.svg"),
        link: "https://element-plus.org/zh-CN/#/zh-CN",
        desc: "基于 Vue 3，面向设计师和开发者的组件库",
      },
      {
        name: "ElementUI",
        icon: require("@/assets/images/icon/element.png"),
        link: "https://element.eleme.cn/#/zh-CN",
        desc: "Element，一套为开发者、设计师和产品经理准备的基于 Vue 2.0 的桌面端组件库",
      },
      {
        name: "Ant Design Vue",
        icon: require("@/assets/images/icon/antd.svg"),
        link: "https://vue.ant.design/docs/vue/introduce-cn/",
        desc: "Ant Design 的 Vue 实现，开发和服务于企业级后台产品。",
      },
      {
        name: "vant",
        icon: require("@/assets/images/icon/vant-weapp.png"),
        link: "https://youzan.github.io/vant/#/zh-CN/intro",
        desc: "有赞团队出品的轻量、可靠的移动端 Vue 组件库",
      },
      {
        name: "cube-ui",
        icon: require("@/assets/images/icon/cube-ui.png"),
        link: "https://didi.github.io/cube-ui/#/zh-CN",
        desc: "滴滴团队基于 Vue.js 实现的精致移动端组件库",
      },
      {
        name: "mint-ui",
        icon: require("@/assets/images/icon/mint-ui.svg"),
        link: "http://mint-ui.github.io/#!/zh-cn",
        desc: "饿了么团队出品的基于 Vue.js 的移动端组件库",
      },

      {
        name: "NutUI",
        icon: require("@/assets/images/icon/nutui.png"),
        link: "http://nutui.jd.com",
        desc: "一套京东风格的轻量级移动端Vue组件库",
      },

      {
        name: "iView",
        icon: require("@/assets/images/icon/iview.png"),
        link: "https://www.iviewui.com/",
        desc: "一套基于 Vue.js 的高质量 UI 组件库",
      },
    ],
  },
  {
    name: "CSS相关",
    icon: "icon-socialcss3outline",
    children: [
      {
        name: "Sass",
        icon: require("@/assets/images/icon/sass.png"),
        link: "https://www.sass.hk/",
        desc: "世界上最成熟、最稳定、最强大的专业级CSS扩展语言！",
      },
      {
        name: "Less",
        icon: require("@/assets/images/icon/less.png"),
        link: "http://lesscss.cn/",
        desc: "它是 CSS，只是多了一点东西。",
      },
      {
        name: "Stylus",
        icon: require("@/assets/images/icon/stylus.svg"),
        link: "http://stylus-lang.com/",
        desc: "富有表现力的、动态的、健壮的CSS",
      },
      {
        name: "Animate.css",
        icon: require("@/assets/images/icon/animate.png"),
        link: "https://daneden.github.io/animate.css/",
        desc: "css内置了很多典型的css3动画,兼容性好使用方便。",
      },
      {
        name: "Can I Use",
        icon: require("@/assets/images/icon/caniuse.png"),
        link: "https://caniuse.com/",
        desc: "一个检测浏览器对JS、HTML5、CSS、SVG或者其他Web前端相关特性支持程度的列表。",
      },
      {
        name: "CSS Inspiration -- CSS灵感",
        icon: require("@/assets/images/icon/css-inspiration.png"),
        link: "https://chokcoco.github.io/CSS-Inspiration/#/",
        desc: "学习 CSS 的灵感，以分类的形式，展示不同 CSS 属性或者不同的课题使用 CSS 来解决的各种方法。",
      },
      {
        name: "ColorSpace",
        icon: require("@/assets/images/icon/color-space.png"),
        link: " https://mycolor.space/",
        desc: "一个生成漂亮的调色板的网站",
      },
      {
        name: "uiGradients",
        icon: require("@/assets/images/icon/uigradients.png"),
        link: "https://uigradients.com/",
        desc: "提供渐变色效果的站点，里面接近上百种渐变配色方案，可根据自己风格来选择搭配，能直接获得对应渐变配色的 CSS 代码。",
      },
      {
        name: "canvas-confetti",
        icon: require("@/assets/images/icon/canvas-confetti.png"),
        link: "https://www.kirilv.com/canvas-confetti/",
        desc: "五彩纸屑发射效果模拟",
      },
    ],
  },
  {
    name: "编辑器/IDE",
    icon: "icon-shebeikaifa",
    children: [
      {
        name: "VS Code",
        icon: require("@/assets/images/icon/vscode.png"),
        link: "https://code.visualstudio.com/",
        desc: "一款免费开源的现代化轻量级代码编辑器，支持几乎所有主流的开发语言的语法高亮、智能代码补全、自定义热键、括号匹配、代码片段、代码对比 Diff、GIT等特性，支持插件扩展，并针对网页开发和云端应用开发做了优化。",
      },
      {
        name: "Sublime Text",
        icon: require("@/assets/images/icon/sublimetext.svg"),
        link: "http://www.sublimetext.com/",
        desc: "神级代码编辑软件(Sublime Text 3),SublimeText是一个代码编辑器。也是HTML和散文先进的文本编辑器。",
      },

      {
        name: "Webstorm",
        icon: require("@/assets/images/icon/webstorm.png"),
        link: "http://www.jetbrains.com/webstorm/",
        desc: "jetbrains公司旗下一款JavaScript 开发工具。目前已经被广大中国JS开发者誉为“Web前端开发神器",
      },
      {
        name: "HBuilder X",
        icon: require("@/assets/images/icon/hbuilderx.png"),
        link: "https://www.dcloud.io/hbuilderx.html",
        desc: "轻如编辑器、强如IDE的合体版本，为极客、为懒人、为你",
      },
      {
        name: "Vim",
        icon: require("@/assets/images/icon/vim.png"),
        link: "https://www.vim.org/",
        desc: "Vim是一个类似于Vi的著名的功能强大、高度可定制的文本编辑器，在Vi的基础上改进和增加了很多特性。",
      },
      {
        name: "Notepad++",
        icon: require("@/assets/images/icon/notepad-plus-plus.svg"),
        link: "https://notepad-plus-plus.org/",
        desc: "Notepad++是 Windows操作系统下的一套文本编辑器(软件版权许可证: GPL),有完整的中文化接口及支持多国语言编写的功能(UTF8技术)。",
      },
    ],
  },
  {
    name: "字体图标",
    icon: "icon-font",
    children: [
      {
        name: "iconfont",
        icon: require("@/assets/images/icon/iconfont.png"),
        link: "https://www.iconfont.cn/",
        desc: "阿里妈妈MUX打造的图标库，是国内功能很强大且图标内容很丰富的矢量图标库。",
      },
      {
        name: "Font Awesome",
        icon: require("@/assets/images/icon/fontawesome.svg"),
        link: "http://fontawesome.dashgame.com/",
        desc: "一款风靡全球的图标字体库和CSS框架。",
      },
      {
        name: "icomoon",
        icon: require("@/assets/images/icon/icomoon.png"),
        link: "https://icomoon.io/",
        desc: "免费开源的字体图标库。",
      },
      {
        name: "MFG Labs icon set",
        icon: require("@/assets/images/icon/mfglabs.png"),
        link: "http://mfglabs.github.io/mfglabs-iconset/",
        desc: "免费字体图标",
      },

      {
        name: "gitmoji",
        icon: require("@/assets/images/icon/gitmoji.png"),
        link: "https://gitmoji.carloscuesta.me/",
        desc: "可以使用在github上的emoji图标",
      },
      {
        name: "Emoji Cheat Sheet",
        icon: require("@/assets/images/icon/emoji-cheat-sheet.png"),
        link: "https://www.webfx.com/tools/emoji-cheat-sheet/",
        desc: "可以使用在github上的emoji图标",
      },
      {
        name: "Emoji searcher",
        icon: require("@/assets/images/icon/emoji.png"),
        link: "https://emoji.muan.co/",
        desc: "Emoji表情大全",
      },
      {
        name: "Ikonate",
        icon: require("@/assets/images/icon/ikonate.png"),
        link: "https://www.ikonate.com/",
        desc: "完全可定制的矢量图标",
      },
    ],
  },
  {
    name: " 辅助开发工具",
    icon: "icon-hebingxingzhuang-",
    children: [
      {
        name: "Git",
        icon: require("@/assets/images/icon/git.png"),
        link: "https://git-scm.com/",
        desc: "版本控制工具",
      },
      {
        name: "YAPI",
        icon: require("@/assets/images/icon/yapi.png"),
        link: "https://hellosean1025.github.io/yapi/",
        desc: "YApi 是高效、易用、功能强大的 api 管理平台，旨在为开发、产品、测试人员提供更优雅的接口管理服务。",
      },
      {
        name: "Codelf",
        icon: require("@/assets/images/icon/codelf.png"),
        link: "https://unbug.github.io/codelf/",
        desc: "Codelf,变量命名,函数命名,方法命名,变量命名神器",
      },
      {
        name: "Bandizip",
        icon: require("@/assets/images/icon/bandizip.png"),
        link: "http://www.bandizip.com/",
        desc: "好用的压缩工具",
      },
      {
        name: "Typora",
        icon: require("@/assets/images/icon/typora.png"),
        link: "https://www.typora.io/",
        desc: "一个适合新手的md编辑器，很好用",
      },
      {
        name: "Snipaste",
        icon: require("@/assets/images/icon/snipaste.svg"),
        link: "https://www.snipaste.com/",
        desc: "最好用的截图软件，没有之一",
      },
      {
        name: "WEB前端助手(FeHelper)",
        icon: require("@/assets/images/icon/feHelper.jpg"),
        link: "https://chrome.google.com/webstore/detail/web%E5%89%8D%E7%AB%AF%E5%8A%A9%E6%89%8Bfehelper/pkgccpejnmalmdinmhkkfafefagiiiad?hl=zh-CN",
        desc: "前端实用工具集，谁用谁知道！",
      },
      {
        name: "JSONView",
        icon: require("@/assets/images/icon/jsonview.jpg"),
        link: "https://chrome.google.com/webstore/detail/jsonview/chklaanhfefbnpoihckbnefhakgolnmc?hl=zh-CN",
        desc: "一款非常实用的格式化和语法高亮JSON格式数据查看器jQuery插件。它是查看json数据的神器。",
      },
      {
        name: "Octotree",
        icon: require("@/assets/images/icon/octotree.jpg"),
        link: "https://chrome.google.com/webstore/detail/octotree/bkhaagjahfmjljalopjnoealnfndnagc?hl=en-US",
        desc: "超实用的GitHub可视化代码树插件",
      },
      {
        name: "Squoosh",
        icon: require("@/assets/images/icon/squoosh.png"),
        link: "https://squoosh.app/",
        desc: "可以离线使用的图片压缩工具",
      },
      {
        name: "TinyPNG",
        icon: require("@/assets/images/icon/tinypng.png"),
        link: "https://tinypng.com/",
        desc: "TinyPNG使用智能有损压缩技术来减少WEBP、JPEG和PNG文件的文件大小。",
      },
    ],
  },
  {
    name: "内容管理",
    icon: "icon-navneirongguanli",
    children: [
      {
        name: "WordPress",
        icon: require("@/assets/images/icon/wordpress.svg"),
        link: "https://cn.wordpress.org/",
        desc: "WordPress是使用PHP语言开发的博客平台，用户可以在支持PHP和MySQL数据库的服务器上架设属于自己的网站。",
      },
      {
        name: "Hexo",
        icon: require("@/assets/images/icon/hexo.svg"),
        link: "https://hexo.io/zh-cn/",
        desc: "快速、简洁且高效的博客框架",
      },
      {
        name: "GitHub Pages",
        icon: require("@/assets/images/icon/github.svg"),
        link: "https://pages.github.com/",
        desc: "Github Pages是Github免费提供给开发者的一款托管个人网站的产品。",
      },
      {
        name: "Jekyll",
        icon: require("@/assets/images/icon/jekyll.png"),
        link: "https://www.jekyll.com.cn/",
        desc: "将纯文本转化为静态网站和博客",
      },
      {
        name: "VuePress",
        icon: require("@/assets/images/icon/vuepress.png"),
        link: "https://www.vuepress.cn/",
        desc: "Vue 驱动的静态站点生成工具",
      },
      {
        name: "Docusaurus",
        icon: require("@/assets/images/icon/docusaurus.svg"),
        link: "https://docusaurus.io/",
        desc: "Facebook出品的 简单的开源文档站点生成器",
      },
      {
        name: "docsify",
        icon: require("@/assets/images/icon/docsify.png"),
        link: "https://docsify.js.org/#/zh-cn/",
        desc: "一个神奇的文档站点生成器 简单轻巧",
      },
      {
        name: "Wiki js",
        icon: require("@/assets/images/icon/wikijs.png"),
        link: "https://wiki.js.org/",
        desc: "一个基于 NodeJS, Git 和 Markdown 的轻量级、现代化以及强大的 WIKI APP 生成工具",
      },
      {
        name: "GitBook",
        icon: require("@/assets/images/icon/gitbook.svg"),
        link: "https://www.gitbook.com/",
        desc: "GitBook 是一个基于 Node.js 的命令行工具，可使用 Github/Git 和 Markdown 来制作精美的电子书",
      },
    ],
  },
];
